<template>
  <div class="p-3 bg-white">
    <shared-add-member
    :client-group-options="clientGroupOptions"
    :client-level-options="clientLevelOptions"
    :custom-fields="customFields"
    @storeMemberSuccess="storeMemberSuccess">
    </shared-add-member>
    <div class="text-center">
      <vs-button id="addMemberButton" class="m-2" color="primary" type="filled" @click.prevent="addMember">{{ $t('save') }}</vs-button>
      <vs-button class="m-2 text-dark" color="transparent" type="filled" @click.prevent="cancel">{{ $t('cancel') }}</vs-button>
    </div>
  </div>
</template>

<script>
import Member from '@/models/Member'
import SharedAddMember from '@/views/Shared/Members/Add'
import { EventBus } from '@/../eventbus'

export default {
  name: 'Window.Member.Add',
  components: {
    SharedAddMember
  },
  data () {
    return {
      clientGroupOptions: [],
      clientLevelOptions: [],
      customFields: {}
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    async initData () {
      try {
        // TODO: Create new API for these options: clientGroupOptions, clientLevelOptions and customFields
        const response = await Member.getSettings()
        this.clientGroupOptions = response.data.meta.options.groups
        this.clientLevelOptions = response.data.meta.options.levels
        this.customFields = response.data.meta.customFields
      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
      }
    },
    addMember () {
      EventBus.$emit('storeMember')
    },
    storeMemberSuccess () {
      this.$windowOpenerHelper.notifyOpener('reload_consultation_callback_member_table')
      window.close()
    },
    cancel () {
      this.$windowOpenerHelper.notifyOpener('reload_consultation_callback_member_table')
      window.close()
    }
  }
}
</script>

<style scoped>

</style>
